<template>
  <div class="dashboard-container flex flex-wrap flex-col">
    <div id="pbi" class="pbiFrame" />
  </div>
</template>

  <script>
// @flow
import { mapActions, mapGetters } from "vuex";

export default {
  name: "HomeBroker",
  data() {
    return {
      biElement: "",
    };
  },
  async mounted() {
    await this.fetchToken();

    if (!this.tokenID) return;
    this.showDash();
  },
  computed: {
    ...mapGetters({
      tokenID: "powerbi/token",
      reportId: "powerbi/reportId",
    }),
  },
  methods: {
    ...mapActions({
      fetchToken: "powerbi/fetchHomeBroker",
    }),
    showDash() {
      const filters = [];
      this.biElement = this.$el.querySelector("#pbi");
      const config = {
        type: "report",
        tokenType: 1,
        accessToken: this.tokenID,
        embedUrl: "https://app.powerbi.com/reportEmbed",
        permissions: 1,
        id: this.reportId,
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: true,
        },
      };
      const rep = window.powerbi.embed(this.biElement, config);
      rep.on("loaded", () => {
        rep.setFilters(filters);
      });
    },
  },
};
</script>

  <style lang="scss">
@import url("./powerbi.css");
</style> 